import type { Panel, VizObjectEditPanel } from '/@viz/elements/toolbars/api'
import type { RoomPartCategory } from '/@viz/lib/objects/roompart'

type ToolsPanelId = `panel/${Panel}/trigger`
type CosmeticPickerToolId = `panel/${Panel}/cosmetic-picker`
type ApplyToAllWallToolId = `panel/${Panel}/apply-to-all-wall`
type ObjectToolbarPanelId = `object-toolbar/${VizObjectEditPanel}`

export type ElementId =
  | ToolsPanelId
  | CosmeticPickerToolId
  | ApplyToAllWallToolId
  | ObjectToolbarPanelId
  | 'panel/elements:product/search'
  | 'panel/room:wallsfloors:edit/add-object'
  | 'panel/room:wallsfloors:edit/object-list'
  | `panel/room:wallsfloors:edit/object-list/${RoomPartCategory}`
  | 'panel/elements/trigger'
  | 'panel/add-text/trigger'
  | 'panel/draw-walls/trigger'
  | 'panel/ruler/trigger'
  | 'panel/plan:add/footer-buttons'
  | 'panel/plan:add/upload'
  | 'panel/upload/trigger'
  | 'panel/wallpaper/object-list'
  | 'panel/wallpaper/object-list/wall'
  | 'smart-add/confirm'
  | 'ruler/measure'
  | 'ruler/basic'
  | 'project-menu'
  | 'vizi-menu'
  | 'undo'
  | 'redo'
  | 'present'
  | 'help'
  | 'share'
  | 'tools/upload/trigger'
  | 'overlay/canvas-size'
  | 'overlay/product-cost'
  | 'overlay/product-cost/toggle'
  | 'object-toolbar/*'
  | 'object-toolbar/crop'
  | 'object-toolbar/delete'
  | 'object-toolbar/effects'
  | 'object-toolbar/fill/trigger'
  | 'object-toolbar/flip'
  | 'object-toolbar/lock'
  | 'object-toolbar/perspective/magic-install'
  | 'object-toolbar/paint'
  | 'object-toolbar/replace'
  | 'object-toolbar/stroke'
  | 'object-toolbar/image'
  | 'object-toolbar/pattern-size'
  | 'object-toolbar/edit'
  | 'object-toolbar/exit'
  | 'object-toolbar/confirm'
  | 'object-toolbar/background'
  | 'object-toolbar/background/magic'
  | 'object-toolbar/background/manual'
  | 'object-toolbar/flip/horizontal'
  | 'object-toolbar/flip/vertical'
  | 'object-toolbar/flip/*'
  | 'object-toolbar/position/send-to-front'
  | 'object-toolbar/position/send-to-back'
  | 'object-toolbar/position/send-forward'
  | 'object-toolbar/position/send-backward'
  | 'object-toolbar/rotate'
  | 'object-toolbar/rotate/left'
  | 'object-toolbar/rotate/right'
  | 'object-toolbar/rotate/*'
  | 'object-toolbar/perspective/magic'
  | 'object-toolbar/pattern-size/decrease'
  | 'object-toolbar/pattern-size/increase'
  | 'object-toolbar/overflow-button'

export const overflowCapableElements = [
  'object-toolbar/rotate',
  'object-toolbar/background',
  'object-toolbar/paint',
  'object-toolbar/replace',
  'object-toolbar/stroke',
  'object-toolbar/image',
  'object-toolbar/pattern-size',
  'object-toolbar/effects',
  'object-toolbar/fill/trigger',
  'object-toolbar/product-info',
  'object-toolbar/scale',
  'object-toolbar/perspective',
  'object-toolbar/fill',
  'object-toolbar/dimensions',
]
